<script setup lang="ts">

interface DesktopBanner {
    type: string;
    source: string;
    typeMobile?: string;
    sourceMobile?: string;
    url: string;
}

interface MobileBanner {
    type?: string;
    source?: string;
    typeMobile: string;
    sourceMobile: string;
    url: string;
}

type Props = DesktopBanner | MobileBanner;

defineProps<Props>();

</script>
<template>
    <a :href="url" target="_blank" class="banner" v-if="(type || typeMobile) && (source || sourceMobile)"
        aria-label="Promo banner">
        <!-- Image banner -->
        <img class="banner__content" :class="{ 'banner__content--desktop': sourceMobile }" v-if="type == 'image'"
            :src="source" alt="">
        <img class="banner__content banner__content--mobile" v-if="typeMobile == 'image' && sourceMobile"
            :src="sourceMobile" alt="">

        <!-- Video banner -->
        <video class="banner__content" :class="{ 'banner__content--desktop': sourceMobile }" ref="video"
            v-if="type == 'video'" :src="source" muted autoplay loop></video>
        <video class="banner__content banner__content--mobile" ref="video" v-if="typeMobile == 'video' && sourceMobile"
            :src="sourceMobile" muted autoplay loop></video>
    </a>
</template>
